import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/system-menu/system-menu.js';
      import {WifiState, AudioState, MicrophoneState, BatteryState, SystemSubMenu} from '@oicl/openbridge-webcomponents/dist/components/system-menu/system-menu.js';

      export interface Props {
     wifiState?: WifiState | undefined;
     audioState?: AudioState | undefined;
     microphoneState?: MicrophoneState | undefined;
     batteryState?: BatteryState | undefined;
     condensed?: boolean;
     showSettingsButton?: boolean;
     activeSubMenu?: SystemSubMenu;
     externalControl?: boolean;
     smallScreen?: boolean
   }

      
  
      export type {WifiState, AudioState, MicrophoneState, BatteryState, SystemSubMenu} from '@oicl/openbridge-webcomponents/dist/components/system-menu/system-menu.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcSystemMenu',
  props: {
    wifiState: {},
    audioState: {},
    microphoneState: {},
    batteryState: {},
    condensed: { type: Boolean },
    showSettingsButton: { type: Boolean },
    activeSubMenu: {},
    externalControl: { type: Boolean },
    smallScreen: { type: Boolean }
  },
  emits: ["wifi-click", "audio-click", "audio-volume-change", "microphone-click", "battery-usage-click", "battery-saving-mode-change", "battery-mode-change", "wifi-network-change", "audio-output-change", "microphone-input-change", "settings-click", "to-sub-menu-click", "wifi-options-click", "wifi-disconnect-click"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onWifiClick: (event: CustomEvent<unknown>) => emit('wifi-click', event as CustomEvent<unknown>),
onAudioClick: (event: CustomEvent<unknown>) => emit('audio-click', event as CustomEvent<unknown>),
onAudioVolumeChange: (event: CustomEvent<unknown>) => emit('audio-volume-change', event as CustomEvent<unknown>),
onMicrophoneClick: (event: CustomEvent<unknown>) => emit('microphone-click', event as CustomEvent<unknown>),
onBatteryUsageClick: (event: CustomEvent<unknown>) => emit('battery-usage-click', event as CustomEvent<unknown>),
onBatterySavingModeChange: (event: CustomEvent<unknown>) => emit('battery-saving-mode-change', event as CustomEvent<unknown>),
onBatteryModeChange: (event: CustomEvent<unknown>) => emit('battery-mode-change', event as CustomEvent<unknown>),
onWifiNetworkChange: (event: CustomEvent<unknown>) => emit('wifi-network-change', event as CustomEvent<unknown>),
onAudioOutputChange: (event: CustomEvent<unknown>) => emit('audio-output-change', event as CustomEvent<unknown>),
onMicrophoneInputChange: (event: CustomEvent<unknown>) => emit('microphone-input-change', event as CustomEvent<unknown>),
onSettingsClick: (event: CustomEvent<unknown>) => emit('settings-click', event as CustomEvent<unknown>),
onToSubMenuClick: (event: CustomEvent<unknown>) => emit('to-sub-menu-click', event as CustomEvent<unknown>),
onWifiOptionsClick: (event: CustomEvent<unknown>) => emit('wifi-options-click', event as CustomEvent<unknown>),
onWifiDisconnectClick: (event: CustomEvent<unknown>) => emit('wifi-disconnect-click', event as CustomEvent<unknown>)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-system-menu',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})